import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import BuildingList from '../components/buildings/BuildingList'

export default function BuildingsPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <BuildingList />
      </Container>
    </main>
  )
}
